// extracted by css-extract-rspack-plugin
export default {"userButton":"A5sl3H7GEnoHEiYf"};